module.exports = __webpack_public_path__ + "static/media/case2.3eb57cc1.png";